// Student Assessments rebuild (Mudassir, Sep-15): counselor assessment work queue.
// The current counselor is derived from auth; never send a counselor id.
import apiClient from 'src/Common/apiClient'

// Paged assessment statuses for the counselor's assigned students.
export const getStudents = async (params = {}) => {
  const response = await apiClient.get('/StudentAssessmentStatus/Students', { params })
  const d = response.data
  if (Array.isArray(d)) return { items: d, totalCount: d.length, pageNumber: 1, totalPages: 1 }
  return d || { items: [], totalCount: 0, pageNumber: 1, totalPages: 0 }
}

// Status for one assigned student.
export const getStudentStatus = async (studentId) => {
  const response = await apiClient.get(`/StudentAssessmentStatus/Students/${studentId}`)
  return response.data
}
